// src/hooks/programs/useCloseProgram.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { closeProgram } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useCloseProgram = () => {
    const queryClient = useQueryClient();

    const {
        mutate: closeProgramMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: closeProgram,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["programs"] });
            queryClient.invalidateQueries({ queryKey: ["program"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to close program");
        },
    });

    return {
        closeProgramMutate,
        isPending: isPending || isLoading,
    };
};

export default useCloseProgram;